import React, { useEffect, useRef } from 'react';

export const useEffectUntilDone = (cb: Function, deps: any[]) => {
    const ran = useRef(false);

    useEffect(() => {
        if (!ran.current) {
            cb(() => {
                ran.current = true;
            });
        }
    }, [cb, ...deps]);
};
